var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allowance-stats tw-grid tw-grid-cols-3",class:{
    'danger-current': _vm.allowances.hasRemainingAllowancesExceeded,
  }},[_c('CurrentAllowance',{attrs:{"allowances":_vm.allowances,"title":_vm.currentAllowanceTitle}}),_c('NewAllowance',{attrs:{"allowances":_vm.allowances,"title":_vm.newAllowanceTitle}}),_c('ChangedAllowance',{attrs:{"allowances":_vm.allowances,"icon-classes":"tw-bg-green-100 tw-text-green-550 tw-transform tw--rotate-90"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }